export { default } from './TaskPanelHeader';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskPanelHeader/index.js